module.exports = __webpack_public_path__ + "media/theme/icon___response-40bc2997.png";